import classNames from "classnames";
import React, { ElementType, ReactElement } from "react";
import TextProps from "./types";

const Text = <C extends ElementType = "p">({
  children,
  className,
  color = "normal",
  element,
  isOnDarkCanvas = false,
  size = "bodyMedium",
  ...rest
}: TextProps<C>): ReactElement => {
  const textClasses = classNames(
    "rds-Text",
    {
      [`rds-Text--${size}`]: size !== "bodyMedium",
      [`rds-Text--${color}`]: color !== "normal",
      "on-darkCanvas": isOnDarkCanvas,
    },
    className
  );

  const Element = element || "p";

  return (
    <Element className={textClasses} {...rest}>
      {children}
    </Element>
  );
};

Text.displayName = "Text";

export { Text as default };
